const RETURN_TO_KEY = 'adminReturnTo'

/** Path the admin panel returns to when closed. */
export function getAdminReturnTo(): string {
  return sessionStorage.getItem(RETURN_TO_KEY) || '/'
}

export function setAdminReturnTo(path: string) {
  sessionStorage.setItem(RETURN_TO_KEY, path)
}
